import { FC } from 'react';
import { useParams } from 'react-router';

// api
import { useGetJobDetails } from '../../../api/jobs';

//utils
import JobStages from './JobStages';
import { getStages } from './JobsUtils';

import { FlexGroup, FlexItem, Loading } from '@lithos';

const JobDetailStages: FC = () => {
  const { jobId } = useParams();

  const { data: jobDetailData, isSuccess: materializationStatusIsSuccess } = useGetJobDetails(jobId ?? '');

  if (!materializationStatusIsSuccess) {
    return (
      <>
        <Loading />
      </>
    );
  }
  const stages = jobDetailData?.attempt_details?.run_details?.stages ?? [];
  const attemptStatus = jobDetailData?.attempt_details?.attempt_status;
  const materializationAttempts = getStages(stages);

  return (
    <>
      <FlexGroup gapSize="4" direction="column" padding="0">
        <FlexItem>
          <JobStages materializationAttempts={materializationAttempts ?? [{}]} materializationStatus={attemptStatus} />
        </FlexItem>
      </FlexGroup>
    </>
  );
};

export default JobDetailStages;
